import { Box, type Colors, Icon, InfoDot, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

export type CircleType = 'circle' | 'circle-line'

export interface FooterElement {
  color?: Colors
  circleType?: CircleType
  shortHand?: string
  description: string
}

interface ScheduleFooterProps {
  footerLegend: FooterElement[]
}

const ScheduleFooter = ({ footerLegend }: ScheduleFooterProps) => {
  const legendItem = (element: FooterElement) => {
    if (element.shortHand) {
      return <Text size="100">{element.shortHand}</Text>
    }
    if (element.color) {
      if (!element.circleType) return null
      return element.circleType === 'circle-line' ? (
        <Icon.Medium icon={element.circleType} color={element.color} />
      ) : (
        <InfoDot size="medium" color={element.color} />
      )
    }
    return null
  }

  return (
    <Box
      border={{ bottom: { color: 'grey200', width: 's1', style: 'solid' } }}
      paddingX="s24"
      paddingY="s8"
      flexDirection="row"
      alignItems="center"
      gap="s12"
    >
      <Box paddingRight="s4">
        <Text size="100">{i18n.t('project_management.schedule.footer.title')}</Text>
      </Box>
      {footerLegend.map((element) => (
        <Box key={element.description} flexDirection="row" alignItems="center" gap="s4">
          {legendItem(element)}
          <Text size="100">{element.description}</Text>
        </Box>
      ))}
    </Box>
  )
}

export default ScheduleFooter
